import { useDispatch, useSelector } from "react-redux";
import { Login } from "../api/services/user";
import { setToken } from "../reducer/userReducer";
import CachedItem, { CacheItem } from "../config/cache";
import { useNavigate } from "react-router-dom";
import { Paths } from "../router/Paths";
import { useToast } from "./useToast";
import { LoadingProps } from "../declarations/commonServices";
import {
  CreateCompany,
  CreateInsuranceProvider,
  DeleteInsuranceProvider,
  GetAllInsuranceProviders,
  UpdateInsuranceProvider,
} from "../api/services/company";
import { RootState } from "../app/store";
import { toast } from "react-toastify";
import { useOwnProfile } from "./useProfile";

interface CompanyData {
  type: string;
  legalIndividualName: string;
  publicCompanyName: string;
  description: string;
  websiteAndSocialMedia: string[];
  streetAdress: string;
  city: string;
  postalCode: string;
  state: string;
  mobilePhone?: string;
  firstName: string;
  lastName: string;
  professionalLicenseNumber: string;
  businessType: string;
  profile?: string;
  profileType?: string;
  numberOfEmployees?: string;
  numberOfActivities?: string;
  locations?: string[];
  reservation?: boolean;
}

export function useCompany() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { account } = useSelector((state: RootState) => state.account);
  const { profile } = useSelector((state: RootState) => state.profile);
  const { getOwnProfile } = useOwnProfile();

  console.log("account", account);
  console.log("profile", profile);

  const accountId = account?._id;
  const profileId = profile?._id;

  const { showResponseMessages } = useToast();
  const {
    legalIndividualName,
    publicCompanyName,
    companyDescription,
    onlineContactInfo,
    streetAddress,
    city,
    postalCode,
    stateRegion,
    phoneNumber,
    firstName,
    lastName,
    companyLogo,
    professionalLicenseNumber,
    legalStatus,
  } = useSelector((state: RootState) => state.registration);

  const createCompany = async (query: LoadingProps) => {
    try {
      // // Load profile data
      // const profileData = await getOwnProfile(query);
      // console.log("Full profile data:", profileData);
      // console.log("Profile ID:", profileData?._id);

      // if (!profileData?._id) {
      //   throw new Error("Profile ID not found");
      // }
      console.log(
        "professionalLicenseNumber create company:",
        professionalLicenseNumber
      );

      // Create FormData
      const formData = new FormData();

      if (companyLogo) {
        // Convert base64 to file
        const byteString = atob(companyLogo.split(",")[1]);
        const mimeString = companyLogo
          .split(",")[0]
          .split(":")[1]
          .split(";")[0];
        const ab = new ArrayBuffer(byteString.length);
        const ia = new Uint8Array(ab);
        for (let i = 0; i < byteString.length; i++) {
          ia[i] = byteString.charCodeAt(i);
        }
        const blob = new Blob([ab], { type: mimeString });
        formData.append("logo", blob, "companyLogo.png");
      }

      formData.append("type", legalStatus);
      formData.append("legalIndividualName", legalIndividualName);
      formData.append("publicCompanyName", publicCompanyName);
      formData.append("companyDescription", companyDescription);
      formData.append("mainAddress", streetAddress);
      formData.append("city", city);
      formData.append("postalCode", postalCode);
      formData.append("state", stateRegion);
      formData.append("locations[]", city);
      formData.append("locations[]", postalCode);
      formData.append("locations[]", stateRegion);
      formData.append("contactPhoneNumber", phoneNumber);
      formData.append("firstName", firstName);
      formData.append("lastName", lastName);
      formData.append("professionalLicenseNumber", professionalLicenseNumber);
      // formData.append("businessType", legalStatus);

      // // Handle onlineContactInfo
      // if (onlineContactInfo) {
      //   onlineContactInfo.forEach((info) => {
      //     formData.append("websiteAndSocialMedia[]", info.value);
      //   });
      // }

      // // Append profile-related data
      // if (profileData.type) formData.append("profileType", profileData.type);
      // if (profileData.numberOfEmployees)
      //   formData.append("numberOfEmployees", profileData.numberOfEmployees);
      // if (profileData.numberOfActivities)
      //   formData.append("numberOfActivities", profileData.numberOfActivities);

      // // Fixing `locations must be an array`
      // if (profileData.locations && Array.isArray(profileData.locations)) {
      //   profileData.locations.forEach((location) => {
      //     formData.append("locations[]", location);
      //   });
      // }

      // Fixing `reservation must be a boolean value`
      // formData.append("reservation", profileData.reservation);

      // Send PUT request with FormData
      const response = await CreateCompany({
        ...query,
        payload: formData,
        profileId: profileId,
      });

      const { message, status, errors, company } = response;
      if (status === 201 || status === 200) {
        message && toast["success"](message);
      } else {
        showResponseMessages(status, message, errors);
      }
    } catch (error) {
      console.error("Error in createCompany:", error);
      showResponseMessages(500, "Failed to create company", [
        "An unexpected error occurred",
      ]);
    }
  };

  const insuranceProvider = async (query: any) => {
    try {
      const response = await CreateInsuranceProvider({
        payload: query.payload,
      });
      console.log("resp", response);
      const { message, status, errors } = response;

      if (status === 201) {
        toast.success("Insurance provider created successfully.");
      } else {
        showResponseMessages(status, message, errors);
      }
    } catch (error) {
      console.error("Error in insuranceProvider:", error);
    }
  };

  const getAllProviders = async (query: { page: number; limit: number }) => {
    try {
      const response = await GetAllInsuranceProviders(query);
      console.log("getAllProviders Response:", response);

      const { message, status, errors, insurance_provider, totalData } =
        response;
      if (status === 200) {
        return { insurance_provider, totalData };
      } else {
        showResponseMessages(status, message, errors);
        return null;
      }
    } catch (error) {
      console.error("Error in getAllProviders:", error);
      showResponseMessages(500, "Failed to fetch insurance providers", [
        "An unexpected error occurred",
      ]);
      throw error;
    }
  };

  const deleteInsuranceProvider = async (query: {
    id: string;
    setLoading: (loading: boolean) => void;
  }) => {
    try {
      const response = await DeleteInsuranceProvider(query);
      console.log("deleteInsuranceProvider Response:", response);

      const { message, status, errors } = response;
      const success = status === 200; // Check if the operation was successful

      if (success) {
        toast.success("Insurance provider deleted successfully.");
      } else {
        showResponseMessages(status, message, errors);
      }
      return { success, message, errors }; // Return success along with other data
    } catch (error) {
      console.error("Error in deleteInsuranceProvider:", error);
      showResponseMessages(500, "Failed to delete insurance provider", [
        "An unexpected error occurred",
      ]);
      return {
        success: false,
        message: "Failed to delete insurance provider",
        errors: [],
      };
    }
  };

  const updateInsuranceProvider = async (query: {
    id: string;
    payload: any;
  }) => {
    try {
      const response = await UpdateInsuranceProvider(query);
      console.log("updateInsuranceProvider Response:", response);

      const { message, status, errors } = response;
      if (status === 200) {
        toast.success("Insurance provider updated successfully.");
      } else {
        showResponseMessages(status, message, errors);
      }
      return response;
    } catch (error) {
      console.error("Error in updateInsuranceProvider:", error);
      showResponseMessages(500, "Failed to update insurance provider", [
        "An unexpected error occurred",
      ]);
      throw error;
    }
  };

  return {
    createCompany,
    insuranceProvider,
    getAllProviders,
    deleteInsuranceProvider,
    updateInsuranceProvider, // Add the new function to the return object
  };
}
